import React from 'react';
import './DeliveryLists.css';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    List,
    ListItem,
    ListItemText,
    Typography
} from "@mui/material";
import {ListItemButton} from "@mui/material";
import axios from "axios";

export function DeliveryLists(props : any) {
    const {} = props;

    const [weeks, setWeeks] = React.useState<any>([]);
    const [expanded, setExpanded] = React.useState<any>(undefined);
    const [loads, setLoads] = React.useState<any>([]);

    const loadLoads = async function () {
        try {
            // const result
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeaders`);
            setLoads(response.data);

            let weeksObject : any = {};
            response.data.forEach((load : any) => {
                let week_number = load.weekNumber;
                if (weeksObject[week_number] === undefined) weeksObject[week_number] = { week_number, list:[] };
                weeksObject[week_number].list.push(load);
            });
            setWeeks(Object.keys(weeksObject).map(k => weeksObject[k]));
        } catch (e) {
            console.log(e);
            // setResult(e);
        }
    };
    React.useEffect(() => {
        loadLoads().then()
    }, []);


    return (
        <>
            <div className="DeliveryLists" style={{padding: '0.5rem', height: 'calc( 100vh - 100px )', overflowY: 'scroll'}}>
                {weeks.map((week : any, index : any) => {
                    return (
                        <Accordion expanded={expanded === week}
                                   onChange={() => setExpanded(expanded === week ? undefined : week)} key={week.week_number}>
                            <AccordionSummary
                                style={{
                                    backgroundColor: (week === expanded) ? '#83AE0D' : (index % 2 === 1) ? '#EBEBEB' : 'white',
                                    color: (week === expanded) ? 'white' : 'black'
                                }}
                            >

                                <Typography style={{ /*width: '33%', flexShrink: 0 ,*/ fontWeight: 800}}>
                                    Week {week.week_number}
                                </Typography>
                                {/*<Typography style={{ color: 'text.secondary' }}>{route['RouteDescription']}</Typography>*/}
                            </AccordionSummary>
                            <AccordionDetails style={{ backgroundColor: '#DDDDDD', flexDirection: 'column' }}>
                                {/*<pre>{JSON.stringify(week.list, undefined, 4)}</pre>*/}
                                <List sx={{width: '100%', bgcolor: 'background.paper'}}>
                                    { week !== undefined && week.list !== undefined && week.list.map((delivery : any, index : any) => {

                                        return (
                                            <ListItem
                                                key={index}
                                                disableGutters
                                            >
                                                <ListItemButton onClick={() => {
                                                    // history.push(`/shipping/pick_list/${load.id}`)
                                                }}>
                                                    <ListItemText primary={`Delivery: ${delivery.brokerDeliveryID} Route: ${delivery.load.route.name}`}/>
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </div>
        </>
    )
}
